module.exports = __webpack_public_path__ + "static/images/mall-gift-bg.71dff57.png";